import axios from "axios";

export default axios.create({
  baseURL: "https://localhost:3500/api",
});
